module.exports = __webpack_public_path__ + "static/media/hr-1541475258969-2048x2048.45edb50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/community-gardens/hr-1541475258969-2048x2048.png
// module id = 831
// module chunks = 13